module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-up-left-f219878b7b8999c3c273cefe5452f680.svg";